module.exports = __webpack_public_path__ + "static/media/emergency.f698f690.svg";